var map = {
	"./ash_brown.png": 712,
	"./beach_blonde.png": 713,
	"./chestnut_brown.png": 714,
	"./chocolate_brown.png": 715,
	"./dark_brown.png": 716,
	"./dirty_blonde18.png": 717,
	"./mochachino_brown.png": 718,
	"./off_black.png": 719,
	"./sterling_sliver.png": 720,
	"./vibrant_red.png": 721,
	"./walnut_brown.png": 722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;